<template>
    <div>
        <div class="forms_accordian forms_accordian-v2 hidedropdown marb10" v-if="isLoaded">
            <div>
                <vs-list-item class="cards-list-heading"> 
                    <h2>{{ docsLabel }} </h2>
                    <div class="d-flex" v-if="false">
                        <label class="download-all" @click="downloadDocs()">
                            Download
                            <img src="@/assets/images/main/download.svg" />
                        </label>
                    </div> 
                </vs-list-item>
            </div>
            
            <vs-collapse accordion class="forms-letters-accordian">
                <template v-for="(forms, indexxx) in documentsList">
                    <!-- hidechild -->
                        <div class="no-accordian has_child_list" :class="{'hidechild':forms.enableChildDoc == false}" :key="indexxx" v-if="checkProperty(forms,'path')">
                            <vs-collapse-item>
                                <div slot="header" class="ss">
                                    <vs-list-item class="documents_accordian">
                                    </vs-list-item>
                                </div>
                                <template>
                                    <div class="list_title">                                        
                                        <div class="documents_accordian_tile">
                                            <!-- :disabled="forms.isDefault && checkProperty(forms,'compressDocFiles') && checkProperty(forms,'compressDocFiles', 'length')>0" -->
                                            <!-- <vs-checkbox :name="'default'+indexxx+'_'" 
                                             @change="selectForArchive(forms, 'Main')" :disabled="forms.isDefault"   v-model="forms.isDefault"></vs-checkbox> -->
                                            <template v-if="checkProperty(forms,'compressDocFiles') && checkProperty(forms,'compressDocFiles', 'length')>0">
                                                <div class="toggle__btn">                                                
                                                    <span v-if="forms.enableChildDoc" @click="updateChildSection(forms)">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="1.796" viewBox="0 0 16 1.796">
                                                            <path id="Path_92346" data-name="Path 92346" d="M10.216-13.008h7.1v1.8h-16v-1.8h8.9Z" transform="translate(-1.318 13.008)" fill="#1d202c"/>
                                                        </svg>                                                      
                                                    </span>

                                                    <span v-if="!forms.enableChildDoc" @click="updateChildSection(forms)" class="mt-2 d-block">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                                            <g id="Group_80327" data-name="Group 80327" transform="translate(-424.457 -683.898)">
                                                            <path id="Path_92347" data-name="Path 92347" d="M10.216-13.008h7.1v1.8h-16v-1.8h8.9Z" transform="translate(423.139 704.008)" fill="#1d202c"/>
                                                            <path id="Path_92348" data-name="Path 92348" d="M10.216-13.008h7.1v1.8h-16v-1.8h8.9Z" transform="translate(420.348 682.58) rotate(90)" fill="#1d202c"/>
                                                            </g>
                                                        </svg>                                                      
                                                    </span> 
                                                </div>
                                            </template>
                                            <docType :item="forms"/> 
                                            <div class="docs_info" @click="fetchSignedUrl(forms);">
                                                <em class="fl_scanned_docs" :title="forms.name">{{ forms.name }}</em>
                                                <small>{{getformated(forms)}}<em v-if="checkProperty(forms,'createdByRoleName')"> ({{ forms['createdByRoleName'] }})</em></small>
                                                
                                                <div class="file_type">
                                                    <label>Original File</label>
                                                    <span v-if="checkProperty(forms, 'size')">{{forms['size'] | convert_bytes}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="documents_actions">

                                            <span v-if="forms.isDefault" class="action_btn selected"><img src="@/assets/images/main/check2.png"/>Selected for Filing</span>
                                            <span @click="forms.isDefault = true;selectForArchive(forms, 'Main')"  v-if="!forms.isDefault"  class="action_btn">Select for Filing</span>
                                            <div class="vertical-menu">
                                                <span class="menu-icon">
                                                    <i class="material-icons">more_vert</i>
                                                </span>
                                                <ul>
                                                    <li @click="showCompress(forms, true)">
                                                        Compress
                                                    </li>
                                                    <li @click="fetchSignedUrl(forms, false, true)">
                                                        View
                                                    </li>
                                                    <li @click="downloads3file(forms)">
                                                        Download
                                                    </li>
                                                    <li @click="uploadFile(forms)">
                                                        Upload
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="child_list_wrap" v-if="checkProperty(forms,'enableChildDoc') && checkProperty(forms,'compressDocFiles') && checkProperty(forms,'compressDocFiles', 'length')>0">
                                        <h4 class="subtitle">Compression Quality</h4>
                                        <div class="child_list_cnt">
                                            <template v-for="(cdForm, indexx) in forms['compressDocFiles']">
                                                <div class="list_title">
                                                <div class="documents_accordian_tile">
                                                    <div class="compress_list-info" @click="fetchSignedUrl(cdForm)">
                                                        <label  class="compress_type cursor" :class="{'best':cdForm.docType == 'Best', 'low':cdForm.docType == 'Low', 'good':cdForm.docType == 'Good', 'average':cdForm.docType == 'Average', 'custom':cdForm.docType == 'Custom'}">
                                                            
                                                            {{checkProperty(cdForm, 'docType')}}</label>
                                                        <span class="filesize" v-if="checkProperty(cdForm, 'size')">{{cdForm['size'] | convert_bytes}} </span>
                                                        <p v-if="checkProperty(cdForm, 'docType') == 'Custom'">Uploaded On {{getUpdateTime(cdForm)}}</p>
                                                        <p v-else>Compressed On {{getUpdateTime(cdForm)}}</p>
                                                    </div>
                                                    <!-- <vs-checkbox  :name="'default'+indexx+'_'" :disabled="cdForm.isDefault" @change="selectFordefault(cdForm, forms)"   v-model="cdForm.isDefault"></vs-checkbox>  -->
                                                    <!-- <docType :item="cdForm" /> -->
                                                    <!-- <span @click="fetchSignedUrl(cdForm);">
                                                        <em class="fl_scanned_docs" :title="cdForm.name">{{ cdForm.name }}</em>
                                                        <small>{{getformated(cdForm)}}<em v-if="checkProperty(cdForm,'createdByRoleName')"> ({{ cdForm['createdByRoleName'] }})</em></small>
                                                    </span> -->
                                                </div>
                                                <div class="document_actions">
                                                    <span v-if="cdForm.isDefault" class="action_btn selected"><img src="@/assets/images/main/check2.png"/>Selected for Filing</span>
                                                    <span @click="cdForm.isDefault = true;selectFordefault(cdForm, forms)"  v-if="!cdForm.isDefault" class="action_btn">Select for Filing</span>
                                                    <div class="vertical-menu">
                                                        <span class="menu-icon">
                                                            <i class="material-icons">more_vert</i>
                                                        </span>
                                                        <ul>
                                                            <li @click="fetchSignedUrl(cdForm, false, true)">
                                                                View
                                                            </li>
                                                            <li @click="downloads3file(cdForm)">
                                                                Download
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                            </vs-collapse-item>
                        </div>
                    </template>
            </vs-collapse>
        </div>
        <vs-popup class="holamundo main-popup cls-btn" title="Select Compression Level" v-if="showCompressPopup" :active.sync="showCompressPopup">
            <form  @submit.prevent data-vv-scope="compressForm" >
                <div class="form-container"> 
                    <div class="vx-row">
                        <div class="custom-radio_wrap wf_radio">
                            <ul class="custom-radio mb-1" >
                                <li v-for="(option, index) in radioOptions" :key="index">
                                    <vs-radio 
                                        :id="'radio_'+index" 
                                        :vs-name="'docType_'"  
                                        :vs-value="option.value" 
                                        v-model="selectedQuality" 
                                        class="w-full"
                                    >
                                        {{ option.label }}
                                    </vs-radio>
                                </li>
                                <input type="hidden" :name="'docType_'" v-validate="'required'" v-model="selectedQuality">
                               
                            </ul>
                            <span class="text-danger text-sm error" v-show="errors.has('compressForm.docType_')">*Field is required</span>
                        </div>
                    </div>
                    <div v-show="comError">
                        <vs-alert
                        color="warning"
                        class="warning-alert reg-warning-alert no-border-radius"
                        icon-pack="IntakePortal"
                        icon="IP-information-button"
                        active="true"
                        >{{ comError }}</vs-alert>
                    </div>
                </div>
                <div class="popup-footer relative">
                    <span class="loader" v-if="compressLoad"><img src="@/assets/images/main/loader.gif"/></span>
                <vs-button color="dark" class="cancel" type="filled" @click="showCompressPopup = false">Cancel</vs-button>
                <vs-button color="success"  class="save" type="filled" @click="updateCompress()">Submit</vs-button>
                </div>
            </form>
        </vs-popup>
        <modal
            :name="'fileuploadComPressPopup'+docIndex"
            classes="v-modal-sec"
            :min-width="200"
            :min-height="200"
            :scrollable="true"
            :reset="true"
            width="600px"
            height="auto"
            >
            <div class="v-modal">
                <div class="popup-header fromDetailsPage">
                <h2 class="popup-title">Upload Document</h2>
                <span @click="$modal.hide('fileuploadComPressPopup'+docIndex)">
                    <em class="material-icons">close</em>
                </span>
                </div>
                <form  @submit.prevent :data-vv-scope="'fileuploadPopup'+docIndex" >
                    <div class="form-container">
                        <div class="vx-row">
                            <fileUploadNote :fileNote="true" />
                            <div class="vx-col w-full">
                                <div class="uploadsec_wrap ff">
                                    <div class="w-full">
                                        <div  @click="uploadMainDocuments=[]">
                                            <file-upload v-model="uploadMainDocuments" :maxData="12288"
                                            :accept="pdfDocEntity" 
                                            class="file-upload-input mb-0" @updateData="updateData" style="height:50px; padding:0px;" :name="'documents'" :multiple="false" :hideSelected="true" v-validate="'required'" label="Scanned Documents" data-vv-as="Scanned Documents"  >
                                                <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                                                Upload
                                            </file-upload>
                                            <span class="file-type mb-0">(File Type: PDF, DOC. Max file size: 12MB)</span>
                                        </div>
                                        <ul class="uploaded-list note_uploads pt-3"
                                            v-if="checkProperty(uploadOriginalDocument, 'length') > 0"
                                            >
                                            <template v-for="(file, fileindex) in uploadOriginalDocument">
                                                <!--- @click="removeLcaDocument(fileindex, premiumProcessingFiles)" --->
                                                <vs-chip
                                                type="button"
                                                @click="removePremiumProcessingFiles(fileindex)"
                                                :key="fileindex"
                                                v-if="file.status !== false"
                                                closable
                                                >{{ file.name }}
                                                </vs-chip>
                                            </template>
                                            </ul>
                                        <VuePerfectScrollbar class="scrollbardoc" v-if="false">
                                            <div class="uploded-files_wrap mt-3" >
                                                <div class="w-full" v-for="(fil, fileindex) in uploadOriginalDocument" :key="fileindex">
                                                    <div class="uploded-files">
                                                        <vx-input-group class="form-input-group">
                                                            <vs-input v-on:keyup="filameChenged(fileindex)"  v-validate="'required'" class="w-full" :name="'fName'+fileindex" v-model="fil['name']" data-vv-as="File Name" />
                                                            <span class="text-danger text-sm" v-show="errors.has('fileuploadPopup'+docIndex+'.fName'+fileindex)">{{ errors.first('fileuploadPopup'+docIndex+'.fName'+fileindex) }}</span>

                                                            <div class="delete" style="z-index:999" @click="remove(fil, uploadOriginalDocument ,fileindex)">
                                                                <img src="@/assets/images/main/cross.svg" />
                                                            </div>
                                                        </vx-input-group>
                                                    </div>
                                                </div>
                                            </div>
                                        </VuePerfectScrollbar>
                                    </div>
                                </div>
                                <div class="text-danger text-sm formerrors mt-2" v-show="formerrors.msg" @click="formerrors.msg=''">
                                    <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius mb-0" icon-pack="IntakePortal"
                                    icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="popup-footer relative">
                        <button @click="fuploder=false;$modal.hide('fileuploadComPressPopup'+docIndex)" class="btn cancel">Cancel</button>
                        <button class="btn save"  @click="updateFormsAndDocuments()" :disabled="!checkProperty(uploadOriginalDocument, 'length')>0">
                            <figure v-if="fuploder" class="loader"><img src="@/assets/images/main/loader.gif" /></figure> Submit
                        </button>
                    </div>
                </form>
            </div>
        </modal>
    </div>
</template>
<script>
import fileUploadNote from "@/views/common/fileUploadNote.vue";
import FileUpload from "@/views/FileUpload.vue";
import NoDataFound from "@/views/common/noData.vue";
import moment from "moment";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import docType from "@/views/common/docType.vue";
import { runInThisContext } from "vm";
import { init } from "events";
import _ from "lodash";
export default {
    components:{
        FileUpload,
        docType,
        VuePerfectScrollbar,
        NoDataFound,
        fileUploadNote
    },
    data: () => ({
        compressLoad:false,
        isLoaded:false,
        fuploder:false,
        disable_uploadBtn:false,
        selectedUploadDoc:null,
        formerrors:{
            msg:''
        },
        uploadOriginalDocument:[],
        uploadMainDocuments:[],
        selectedQuality:'',
        showCompressPopup:false,
        picked: 1,
        radioOptions: [
            { label: 'Best', value: 'Best' },
            { label: 'Good', value: 'Good' },
            { label: 'Average', value: 'Average' },
            { label: 'Low', value: 'Low' }
        ],
        comError:'',
    }),
    props:{
        tagItemId:null,
        docIndex:null,
        USCISDownLoads:{
            type: Boolean,
            default: false,
        },
        recentDownLoads:{
            type: Boolean,
            default: false,
        },
        uploadFormsAndLetters:{
            type: Boolean,
            default: false,
        },
        callFromGroupDocs:{
            type: Boolean,
            default: false,
        },
        callFromCaseDocs:{
            type: Boolean,
            default: false,
        },
        documentsList:{
            type: [Object,Array],
            default: [],
        },
        petition: {
            type: Object,
            default: null,
        },
        loadedFromPreview:{
            type: Boolean,
            default: false,
        },
        docUserType:{
            type: String,
            default: '',
        },
        docsLabel:{
            type: String,
            default: '',
        },
        docCategory:{
            type: String,
            default: '',
        },
        childId:{
            type: String,
            default: '',
        },
        depLabel:{
            type: String,
            default: '',

        },
        depType:{
            type: String,
            default: '',

        },
    },
    mounted(){
        // if(this.checkProperty(this.documentsList, 'length')>0){
        //     _.map(this.documentsList, (dcItm)=>{
        //         dcItm['enableChildDoc'] = true;
                
        //     })
        // }
        if(this.checkProperty(this.documentsList, 'length')>0){
            _.forEach(this.documentsList, (dcItm)=>{
                if(!_.has(dcItm, 'isDefault')){
                    dcItm['isDefault'] = false;
                }
                if(dcItm && dcItm['compressDocFiles'] && this.checkProperty(dcItm,'compressDocFiles', 'length')>0){
                    _.forEach(dcItm['compressDocFiles'], (chItm)=>{
                        if(!_.has(chItm, 'isDefault')){
                            chItm['isDefault'] = false;
                        }
                    })
                }
            })
            this.documentsList =_.cloneDeep(this.documentsList)
        }
        this.isLoaded = true
    //   init()
    },
    methods:{
        downloadDocs(){
            let self = this;
            let selectedDocPaths = [];
            if(this.checkProperty(this.documentsList, 'length')>0){
                let obj = {
                    name:this.docsLabel,
                    documents:[]
                };
                _.forEach(this.documentsList, (mItem)=>{
                    if(mItem && mItem['isDefault']){
                        obj['documents'].push(mItem)
                    }else if(mItem && mItem['compressDocFiles']&& mItem['compressDocFiles'].length>0){
                        _.forEach(mItem['compressDocFiles'], (cDoc)=>{
                            if(cDoc && cDoc['isDefault']){
                                obj['documents'].push(cDoc)
                            }
                        })
                    }
                })
                if(self.checkProperty(obj, 'documents', 'length')>0){
                    selectedDocPaths.push(obj)
                }
                obj = {name:'',documents:[]};
                console.log(JSON.stringify(selectedDocPaths))
            }
            if(this.checkProperty(this.groupMergedDocs, 'length')>0 && false){
                let selectedDocPaths = [];
                _.forEach(self.groupMergedDocs, (gDocs)=>{
                    let obj = {
                        name:this.getLabels(gDocs['_id']),
                        documents:[]
                    };
                    if(self.checkProperty(gDocs, 'documents', 'length')>0){
                        _.forEach(gDocs['documents'], (pDoc)=>{
                            if(pDoc && pDoc['isDefault']){
                                obj['documents'].push(pDoc)
                            }else if(pDoc && pDoc['compressDocFiles']&& pDoc['compressDocFiles'].length>0){
                                _.forEach(pDoc['compressDocFiles'], (cDoc)=>{
                                    if(cDoc && cDoc['isDefault']){
                                        obj['documents'].push(cDoc)
                                    }
                                })
                            }
                        })
                        if(self.checkProperty(obj, 'documents', 'length')>0){
                            selectedDocPaths.push(obj)
                        }
                        obj = {
                            name:'',
                            documents:[]
                        };
                    }

                });
                console.log(JSON.stringify(selectedDocPaths))
            }
        },
        removePremiumProcessingFiles(index){
            this.uploadMainDocuments = [];
            let item=this.uploadOriginalDocument[index]
            this.uploadOriginalDocument.splice(index ,1)
            this.removeFileFromS3(item)
        },
        kbToMb(kb) {
            let reurnVal = null
            if(kb){
                reurnVal =  (kb / (1024 * 1024));
                reurnVal =  reurnVal.toFixed(2)
                // reurnVal =  kb/1024;
                // reurnVal =  reurnVal.toFixed(2)
            }
            return reurnVal;
        },
        selectFordefault(chid = null, paret = null){
            this.$emit('selectFordefault', chid, paret, this.docIndex);
            if(chid['isDefault']){
                let Pyload={
                    compressEfileId:this.checkProperty(paret, '_id'),
                    setDefType:'child',
                    childId:this.checkProperty(chid, '_id'),
                };
                this.$store.dispatch('commonAction', {data:Pyload,path:'/documents/efile-doc-set-as-default'}).then((resp)=>{

                }).catch((err)=>{})
            }
            // let childDoc = chid;
            // let parentDoc = paret
            // let action = this.checkProperty(childDoc, 'isDefault');
            // if(action && this.checkProperty(parentDoc, 'compressDocFiles') && this.checkProperty(parentDoc, 'compressDocFiles', 'length')>0  ){
            //     parentDoc['isDefault'] = false;
            //     _.forEach(parentDoc['compressDocFiles'], (cItem)=>{
            //         if(cItem['path'] != childDoc['path']){
            //             cItem['isDefault'] = false;
            //         }
            //     })
            //     _.map(this.documentsList, (dcos)=>{
            //         if(dcos['path'] == parentDoc['path']){
            //             dcos['isDefault'] = parentDoc['isDefault']
            //             dcos['compressDocFiles'] = parentDoc['compressDocFiles']
            //         }
            //     })

            // }
        },
        selectForArchive(dc){
            this.$emit('selectForArchive', dc, this.docIndex);
            if(dc['isDefault']){
                let Pyload={
                    compressEfileId:this.checkProperty(dc, '_id'),
                    setDefType:'parent'
                };
                this.$store.dispatch('commonAction', {data:Pyload,path:'/documents/efile-doc-set-as-default'}).then((resp)=>{

                }).catch((err)=>{})
            }
            // let form = dc
            // let action = this.checkProperty(form, 'isDefault')
            // if(action && this.checkProperty(form, 'compressDocFiles') && this.checkProperty(form, 'compressDocFiles', 'length')>0 ){
            //     _.forEach(form['compressDocFiles'], (cItem)=>{
            //         cItem['isDefault'] = false;
            //     })
            //     _.map(this.documentsList, (dcos)=>{
            //         if(dcos['path'] == form['path']){
            //             dcos['compressDocFiles'] = form['compressDocFiles']
            //         }
            //     })
            // };
           
        },
        updateFormsAndDocuments(){
            this.$validator.validateAll('fileuploadPopup'+this.docIndex).then(result => {
                if(result){
                    let payLoad = {
                        compressEfileId:'',
                        document:null
                    }
                    if(this.checkProperty(this.selectedUploadDoc, '_id')){
                        payLoad['compressEfileId'] = this.checkProperty(this.selectedUploadDoc, '_id');
                    }
                    if(this.checkProperty(this.uploadOriginalDocument, 'length')>0){
                        payLoad['document'] = this.uploadOriginalDocument[0];
                        payLoad['document']['docType'] = 'Custom'
                    }
                    this.fuploder = true;
                    this.$store.dispatch('commonAction', {data:payLoad,path:'/documents/compress-efile-doc'}).then((resp)=>{
                        this.uploadOriginalDocument = [];
                        this.fuploder = false;
                        this.$emit('getDocsLibrary', this.tagItemId, this.checkProperty(this.selectedUploadDoc, '_id'))
                        this.$modal.hide('fileuploadComPressPopup'+this.docIndex)
                    }).catch((err)=>{
                        this.fuploder = false;
                        this.formerrors['msg'] = err
                    })
                    // console.log(JSON.stringify(this.selectedUploadDoc))
                    // console.log(JSON.stringify(this.uploadOriginalDocument))
                }
            })
           
        },
        remove(item, type) {
            type.splice(type.indexOf(item), 1);
            this.removeFileFromS3(item)
            return false;
        },
        filameChenged(fileindex) {
            this.disable_uploadBtn = false;
            if (this.uploadOriginalDocument.length > 0) {
                _.forEach(this.uploadOriginalDocument, (fl, value) => {
                    let fname = fl.document.name;
                    fname = fname.trim();
                    if (!fname) {
                        this.disable_uploadBtn = true;
                    }
                });
            }
        },
        uploadFile(doc){
            this.selectedUploadDoc = doc;
            this.uploadMainDocuments = [];
            this.uploadOriginalDocument = [];
            this.$modal.show('fileuploadComPressPopup'+this.docIndex)
        },
        updateData(docs){
            let file = docs;
            if(file && file.length>0){
                _.forEach(file, (it)=>{
                    if(this.checkProperty(this.selectedUploadDoc, 'name')){
                        it['name'] = this.checkProperty(this.selectedUploadDoc, 'name')
                    }
                })
                file = _.cloneDeep(file)
            }
            this.uploadOriginalDocument = file;
        },
        updateCompress(){
            let self = this;
            this.$validator.validateAll('compressForm').then(result => {
                if(result){
                    let payLoad = {
                        document:this.compressSelectedItem,
                        quality:this.selectedQuality
                    };
                    this.comError = '';
                    this.compressLoad = true;
                    this.$store.dispatch('commonAction', {data:payLoad,path:'/common/compress-file'}).then((resp)=>{
                        let res = resp;
                        if(res){
                            res['uploadedBy'] = self.checkProperty(self.getUserData,'userId')!=''?self.checkProperty(self.getUserData,'userId'):null;
                            res['uploadedByName'] = self.checkProperty(self.getUserData,'name')!=''?self.checkProperty(self.getUserData,'name'):'';
                            res['uploadedByRoleId'] = self.getUserRoleId?self.getUserRoleId:null;
                            res['uploadedByRoleName'] = self.checkProperty(self.getUserData,'loginRoleName');
                            res['docType'] = self.selectedQuality;
                            let pLoad = {
                                compressEfileId:this.checkProperty(this.compressSelectedItem, '_id'),
                                document:res
                            };
                            this.$store.dispatch('commonAction', {data:pLoad,path:'/documents/compress-efile-doc'}).then((resp)=>{
                                this.$emit('getDocsLibrary', this.tagItemId, this.checkProperty(this.compressSelectedItem, '_id'))
                                this.compressLoad = false;
                                this.showCompressPopup = false
                            }).catch((err)=>{
                                this.comError = err;
                                this.compressLoad = false;
                            })
                        }else{
                            this.compressLoad = false;
                            this.showCompressPopup = false
                        }
                        // console.log(JSON.stringify(resp));
                        
                    }).catch((err)=>{
                        this.compressLoad = false;
                        this.comError = err
                    })
                    
                }
            })
        },
        showCompress(doc = null, showpopup = false){
            this.selectedQuality = '';
            this.compressLoad = false;
            this.comError = '';
            this.compressSelectedItem = doc;
            this.showCompressPopup = showpopup;
        },
        updateChildSection(val){
            let formItem = val
            _.forEach(this.documentsList, (dItem)=>{
                if(dItem['_id'] == formItem['_id']){
                    dItem['enableChildDoc'] = !dItem['enableChildDoc']
                }
            })
            this.documentsList = _.cloneDeep(this.documentsList)
        },
        init(){
            if(this.checkProperty(this.documentsList, 'length')>0){
                _.map(this.documentsList, (dcItm)=>{
                    if(!_.has(dcItm, 'isDefault')){
                        dcItm['isDefault'] = false;
                        console.log(JSON.stringify(dcItm))
                    }
                    if(dcItm && dcItm['compressDocFiles'] && this.checkProperty(dcItm,'compressDocFiles', 'length')>0){
                        _.map(dcItm['compressDocFiles'], (chItm)=>{
                            if(!_.has(chItm, 'isDefault')){
                                chItm['isDefault'] = false;
                            }
                        })
                    }
                })
            }
        },

        getUpdateTime(item){
            let msg = '';
            if (item.createdOn) {
                msg = moment(item.createdOn).format("MMM DD, YYYY hh:mm:ss A")
            }
            return msg
        },

        getformated(item) {
            if (item.createdOn) {
                    let msg = "Uploaded On  " + moment(item.createdOn).format("MMM DD, YYYY hh:mm:ss A")
                    if(item.createdByName){
                        msg=  msg+" - Uploaded By "+item.createdByName
                    }else if( item.uploadedByName){
                        msg=  msg+" - Uploaded By "+item.uploadedByName
                    }
                return msg
            }else {
                    return '';
                }
          
            // if(this.checkProperty(item,'generated') == true || this.checkProperty(item,'generated') == 'true' ){
               
               
            //     if (item.createdOn) {
            //         let msg = "Generated On " + moment(item.createdOn).format("MMM DD, YYYY hh:mm:ss a")
            //         if(this.recentDownLoads){
            //             msg = "Downloaded On " + moment(item.createdOn).format("MMM DD, YYYY hh:mm:ss a")
            //         }
                    
            //         if(item.createdByName){
                       
            //             if(this.recentDownLoads){
            //                 msg=  msg+" - Downloaded By "+item.createdByName
            //             }else{
            //                 msg=  msg+" - Generated By "+item.createdByName
            //             }
            //         }else if( item.uploadedByName){
            //             if(this.recentDownLoads){
            //                 msg=  msg+" - Downloaded By "+item.uploadedByName
            //             }else{
            //                 msg= msg+" - Generated By "+item.uploadedByName
            //             }
                       
            //         }
            //     return msg//( "Uploaded On  " + moment(item.createdOn).format("MMM DD, YYYY hh:mm:ss a") +" - Uploaded By " + item.createdByName );
            // } else if (item.uploadedOn) {
            //     let msg = "Generated On   " + moment(item.uploadedOn).format("MMM DD, YYYY hh:mm:ss a")
            
            //     if(this.recentDownLoads){
            //         msg = "Downloaded On " + moment(item.uploadedOn).format("MMM DD, YYYY hh:mm:ss a")
            //     }
            //         if(item.createdByName){
            //             if(this.recentDownLoads){
            //                 msg=  msg+" - Downloaded By "+item.createdByName
            //             }else{
            //                 msg=  msg+" - Generated By "+item.createdByName
            //             }
            //         }else if( item.uploadedByName){
            //             if(this.recentDownLoads){
            //                 msg=  msg+" - Downloaded By "+item.uploadedByName
            //             }else{
            //                 msg= msg+" - Generated By "+item.uploadedByName
            //             }
            //         }
            //         return msg;
            // } else if(item.uploadedByName){
               
               
            //    return "Uploaded By "+item.uploadedByName
               
            // }else {
            //     return '';
            // }

           
            // }else{
               
            //     if (item.createdOn) {
            //         let msg = "Uploaded On  " + moment(item.createdOn).format("MMM DD, YYYY hh:mm:ss a")
            //         if(this.recentDownLoads){
            //            msg = "Downloaded On " + moment(item.createdOn).format("MMM DD, YYYY hh:mm:ss a")
            //        }
                   
            //         if(item.createdByName){
            //             if(this.recentDownLoads){
            //                 msg=  msg+" - Downloaded By "+item.createdByName
            //             }else{
            //                 msg=  msg+" - Uploaded By "+item.createdByName
            //             }
            //         }else if( item.uploadedByName){
            //             if(this.recentDownLoads){
            //                 msg=  msg+" - Downloaded By "+item.uploadedByName
            //             }else{
            //                 msg=  msg+" - Uploaded By "+item.uploadedByName
            //             }
            //         }
            //     return msg//( "Uploaded On  " + moment(item.createdOn).format("MMM DD, YYYY hh:mm:ss a") +" - Uploaded By " + item.createdByName );
            //     } else if (item.uploadedOn) {
            //     let msg = "Uploaded On  " + moment(item.uploadedOn).format("MMM DD, YYYY hh:mm:ss a")


            //         //alert(item.createdByName + "item.uploadedByName "+item.uploadedByName)
            //             if(item.createdByName){
            //                 if(this.recentDownLoads){
            //                     msg=  msg+" - Downloaded By "+item.createdByName
            //                 }else{
            //                     msg=  msg+" - Uploaded By "+item.createdByName
            //                 }
            //             }else if( item.uploadedByName){
            //                 if(this.recentDownLoads){
            //                     msg=  msg+" - Downloaded By "+item.uploadedByName
            //                 }else{
            //                     msg=  msg+" - Uploaded By "+item.uploadedByName
            //                 }
            //             }
            //             return msg;
            //     } else  if(item.uploadedByName){
                
                
            //     return "Uploaded By "+item.uploadedByName
                
            //     }else {
            //         return '';
            //     }
            // }
        },

       


        fetchSignedUrl(value,download = false, viewmode = false) {
          value.download = download;
            value.viewmode = viewmode;
            this.$emit('download_or_view' ,value);
        },
    },
    computed:{

    }

}
</script>